import React, { createContext, useContext } from 'react';

// Context for sharing workflow data with node components
const WorkflowContext = createContext({
  providers: [],
  updateNodeConfig: () => {},
});

export const WorkflowProvider = WorkflowContext.Provider;

export const useWorkflow = () => useContext(WorkflowContext);

export default WorkflowContext;

